module.exports = require("highlight.js/lib/languages/nginx");